// extracted by mini-css-extract-plugin
export var basebutton = "Pagination-module--basebutton--a3add";
export var disabled = "Pagination-module--disabled--1721c Pagination-module--basebutton--a3add";
export var next = "Pagination-module--next--ed6bd Pagination-module--basebutton--a3add";
export var pagination = "Pagination-module--pagination--7eadc";
export var paginationcontainer = "Pagination-module--paginationcontainer--f7aa1";
export var paginationcontainerhidden = "Pagination-module--paginationcontainerhidden--260a6 Pagination-module--paginationcontainer--f7aa1";
export var paginationlink = "Pagination-module--paginationlink--5ffe5";
export var paginationtext = "Pagination-module--paginationtext--015bc";
export var paginationtoggletab = "Pagination-module--paginationtoggletab--9acd4";
export var paginationwrapper = "Pagination-module--paginationwrapper--a162e";
export var previous = "Pagination-module--previous--f7731 Pagination-module--basebutton--a3add";